import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useState } from 'react';
import { NavItemEnum } from '../../constants/routing/NavItems';
import useCreditsPageNavItemTabs from '../../hooks/useCreditsPageTabNavItems';
import { useAppSelector } from '../../reducers';
import { billingNameKeySelector, currentProductVersionSelector, currentSkuIdForProductSelector, currentSuiteSkuIdsForProductLevelSelector } from '../../selectors/ProductsSelectors';
import { getProductLineForNavItem } from '../../utils/routingUtils';
import { trackButtonClick } from '../../utils/tracking/trackingEventUtils';
import HubSpotCreditsFeatures from '../key-features/HubSpotCreditsFeatures';
import { HubSpotCreditsTilesContainerInbound25 } from '../merch-card/hubspot-credits/HubSpotCreditsTilesContainerInbound25';
import BillingNameTitle from './BillingNameTitle';
import NavItemTabs from './NavItemTabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UnlockAIContentTabLayout = () => {
  const isMobile = useIsMobile();
  const tabs = useCreditsPageNavItemTabs();
  const [subscreen, setSubscreen] = useState(tabs[0]);
  const productLine = getProductLineForNavItem(subscreen);
  const billingNameKey = useAppSelector(state => {
    if (subscreen === NavItemEnum.SUITE || !productLine) return 'crm-suite-starter-bundle';
    const productVersion = currentProductVersionSelector(state, {
      productLine,
      productLevel: 'PROFESSIONAL'
    });
    if (!productVersion) return null;
    return billingNameKeySelector(state, {
      skuId: productVersion.skuId
    });
  });
  const skuIds = useAppSelector(state => {
    if (subscreen === NavItemEnum.SUITE || !productLine) {
      return currentSuiteSkuIdsForProductLevelSelector(state, {
        productLevel: 'STARTER'
      });
    }
    const skuId = currentSkuIdForProductSelector(state, {
      productLine,
      productLevel: 'PROFESSIONAL'
    });
    if (!skuId) return [];
    return [skuId];
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavItemTabs, {
      selected: subscreen,
      setSelected: tab => {
        trackButtonClick({
          value: tab
        });
        getUsageTracker().setProperties({
          subscreen: tab
        });
        setSubscreen(tab);
      },
      tabs: tabs
    }), /*#__PURE__*/_jsxs(View, {
      backgroundColor: "fill-surface-default",
      padding: isMobile ? '0' : '1300',
      children: [/*#__PURE__*/_jsx(HubSpotCreditsTilesContainerInbound25, {
        subscreen: subscreen,
        unlockHubSpotCreditsSkuIds: skuIds,
        title: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "pricingPage.pages.hubspot-credits.unlockAI.title.withBillingName",
          options: {
            billingName: billingNameKey ? /*#__PURE__*/_jsx(BillingNameTitle, {
              bilingNameKey: billingNameKey
            }) : null
          }
        })
      }), /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })]
    })]
  });
};
export default UnlockAIContentTabLayout;